import Navbar from "components/Navbar"
import Footer from "components/Footer";
import { useSelector } from "react-redux";
import MobileNavbar from "components/MobileNavbar";
import MobileFooter from "components/MobileFooter";
import SeminarPage from "components/Seminar/SeminarPage"
import { useEffect } from "react";


function Seminars () {

    const isMobile = useSelector(state => state.windowSize.isMobile);

    useEffect(() => {
        window.scrollTo({ top: 0, left: 0, behavior: "auto" });
    }, []);

    return(
        <>
        {isMobile ? (
            <>
            <MobileNavbar />
            <SeminarPage />
            <MobileFooter />
            </>
        ) : (
            <>
            <Navbar />
            <SeminarPage />
            <Footer />
            </>
        )}
        </>
    )
}

export default Seminars